<template>
  <v-card class="orden-detalle-redesign" color="white" min-width="100%" elevation="0">

    <!-- PROPINA: misma funcionalidad, nueva presentación -->
    <v-dialog v-model="dialogPropina" max-width="500" persistent>
      <v-card class="redesign-dialog">
        <v-card-title class="redesign-dialog-title">
          <div>
            <span class="dialog-kicker">Orden</span>
            <strong>Propina</strong>
          </div>
        </v-card-title>

        <v-card-text class="redesign-dialog-body">
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Porcentaje"
                type="number"
                v-model="porcentajePropina"
                @change="calcularPropina"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Propina"
                type="number"
                v-model="posenc.dblPropina"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="redesign-dialog-actions">
          <v-spacer />
          <v-btn text @click="dialogPropina = false">Cancelar</v-btn>
          <v-btn class="redesign-primary-btn" dark @click="agregarPropinaOrden">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Keyboard v-model="keyboard" layout="compact" />

    <!-- CABECERA -->
    <div class="orden-head">
      <div class="orden-head-main">
        <div class="orden-kicker">Detalle de orden</div>
        <h2 v-if="posenc.intOrden > 0">{{ title }}    {{" #" + posenc.intOrden }}</h2>
        <h2 v-else>Nueva {{ title }}</h2>
        <div class="orden-meta">
          <span>{{ detalles.length }} productos</span>
          <span v-if="posenc.intOrden > 0">Orden activa</span>
        </div>
      </div>

      <div class="orden-head-actions" v-if="version == 'desktop'">
        <button class="detail-icon-btn" type="button" @click="opcionesorden()" title="Opciones">
          <v-icon>mdi-format-list-bulleted</v-icon>
        </button>
        <button class="detail-icon-btn" type="button" @click="imprimir()" title="Imprimir">
          <v-icon>mdi-printer-outline</v-icon>
        </button>
        <button class="detail-icon-btn" type="button" @click="propina()" title="Propina">
          <v-icon>mdi-currency-usd</v-icon>
        </button>
      </div>
    </div>

    <!-- ACCIONES MOBILE: mismas funciones -->
    <div class="orden-mobile-actions" v-if="version == 'mobile'">
      <button type="button" @click="opcionesorden()">
        <v-icon>mdi-format-list-bulleted</v-icon>
        <span>Opciones</span>
      </button>
      <button type="button" @click="imprimir()">
        <v-icon>mdi-printer-outline</v-icon>
        <span>Imprimir</span>
      </button>
      <button type="button" @click="propina()">
        <v-icon>mdi-currency-usd</v-icon>
        <span>Propina</span>
      </button>
    </div>

    <!-- CONTENIDO DE PRODUCTOS -->
    <div class="orden-body">
      <div class="orden-section-label">
        <span>Productos de la orden</span>
        <span class="orden-count">{{ detalles.length }}</span>
      </div>

      <div class="orden-items">
        <v-expansion-panels
          v-model="panelAbierto"
          multiple
          class="redesign-expansion"
        >
          <!-- PRODUCTOS ACTIVOS -->
          <v-expansion-panel
            v-for="(detalle, index) in detalles"
            :key="'activo-' + index"
            class="redesign-item"
          >
            <v-expansion-panel-header class="redesign-item-header" hide-actions>
              <div class="item-summary">
                <div class="item-main">
                  <div class="item-title-row">
                    <v-chip
                      v-if="detalle.intPreparado == null && config_37_activo"
                      x-small
                      class="new-chip"
                    >
                      NUEVO
                    </v-chip>
                    <strong class="item-name">
                      ({{ detalle.dblCantidad }}) {{ detalle.strNombre }}
                    </strong>
                  </div>
                  <span class="item-price">{{ toMoney(detalle.dblTotal) }}</span>
                </div>

                <div class="item-actions" @click.stop>
                  <button
                    class="item-action"
                    type="button"
                    @click.stop="opciones(detalle, index)"
                    title="Opciones"
                  >
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </button>

                  <button
                    class="item-action"
                    type="button"
                    @click.stop="imprimirDetalle(detalle, index)"
                    title="Imprimir"
                  >
                    <v-icon>mdi-printer-outline</v-icon>
                  </button>

                  <button
                    class="item-toggle"
                    type="button"
                    title="Mostrar detalle"
                  >
                    <v-icon>mdi-chevron-down</v-icon>
                  </button>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="redesign-item-content">
              <div class="detail-content">

                <div
                  v-if="detalle.posDetArticuloConfiguracion && detalle.posDetArticuloConfiguracion.length"
                  class="detail-configurations"
                >
                  <div class="detail-subtitle">Configuración</div>

                  <div
                    v-for="configuracion in detalle.posDetArticuloConfiguracion"
                    :key="configuracion.intPOSArticuloConfiguracion"
                    class="configuration-row"
                  >
                    <span>
                      ({{ configuracion.dblCantidad }})
                      {{ configuracion.strNombre }}
                    </span>
                    <strong>{{ toMoney(configuracion.dblTotal) }}</strong>
                  </div>
                </div>

                <div class="detail-overview">
                  <div class="detail-overview-grid">
                    <div>
                      <span>Cantidad</span>
                      <strong>{{ detalle.dblCantidad }}</strong>
                    </div>
                    <div>
                      <span>Precio</span>
                      <strong>{{ toMoney(detalle.dblTotal) }}</strong>
                    </div>
                    <div>
  <span>Descuento</span>
  <strong>{{ Number(detalle.dblPorcentajeDescuento || 0) + "%" }}</strong>
</div>
                    <div>
                      <span>IVA</span>
                      <strong>{{ toPercent(detalle.dblPorcentajeIVA / 100) }}</strong>
                    </div>
                  </div>

                  <div class="detail-subtotal">
                    <span>Subtotal</span>
                    <strong>{{ toMoney(detalle.dblTotal) }}</strong>
                  </div>
                </div>

                <div class="detail-note">
                  <v-textarea
                    dense
                    v-model="detalle.strNota"
                    outlined
                    auto-grow
                    rows="1"
                    label="Nota"
                    hide-details
                    @click="showKeyboard($event)"
                  />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- PRODUCTOS CANCELADOS / DEVUELTOS -->
          <v-expansion-panel
            v-for="(detalle, index) in detallesCancelados"
            :key="'cancelado-' + (index + 100)"
            class="redesign-item redesign-item-cancelled"
          >
            <v-expansion-panel-header class="redesign-item-header" hide-actions>
              <div class="item-summary">
                <div class="item-main">
                  <strong class="item-name">
                    ({{ detalle.dblCantidad }}) {{ detalle.strNombre }}
                  </strong>
                  <span class="item-price">{{ toMoney(detalle.dblTotal) }}</span>
                </div>

                <div class="cancelled-badge">
                  {{ detalle.intCancelacionDevolucion == 9 ? 'Cancelado' : 'Devuelto' }}
                </div>

                <div class="item-toggle">
                  <v-icon>mdi-chevron-down</v-icon>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="redesign-item-content">
              <div class="detail-content cancelled-content">
                <p v-if="detalle.intCancelacionDevolucion == 9">
                  <strong>Cancelado</strong>
                  <span>{{ detalle.strComentarioCancelacion }}</span>
                </p>
                <p v-if="detalle.intCancelacionDevolucion == 8">
                  <strong>Devuelto</strong>
                  <span>{{ detalle.strComentarioCancelacion }}</span>
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- ENVÍO -->
          <v-expansion-panel
            v-if="this.posenc.dblEnvio1 > 0"
            class="redesign-item redesign-item-shipping"
          >
            <v-expansion-panel-header class="redesign-item-header" hide-actions>
              <div class="item-summary">
                <div class="item-main">
                  <strong class="item-name">ENVÍO</strong>
                  <span class="item-price">{{ toMoney(this.posenc.dblEnvio1) }}</span>
                </div>
                <div class="shipping-badge">
                  <v-icon small>mdi-truck-outline</v-icon>
                </div>
                <div class="item-toggle">
                  <v-icon>mdi-chevron-down</v-icon>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="redesign-item-content">
              <div class="detail-content shipping-content">
                <span>Costo de envío</span>
                <strong>{{ toMoney(this.posenc.dblEnvio1) }}</strong>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- VACÍO -->
        <div v-if="!detalles.length && !detallesCancelados.length && !posenc.dblEnvio1" class="orden-empty">
          <div class="empty-icon">
            <v-icon>mdi-receipt-text-outline</v-icon>
          </div>
          <strong>Sin productos</strong>
          <span>Agrega productos a la orden para comenzar.</span>
        </div>
      </div>
    </div>

    <!-- RESUMEN / NOTA / FLUJO -->
    <div class="orden-foot">
      <div v-if="posenc.dblPropina > 0" class="tip-row">
        <span>Propina</span>
        <strong>{{ toMoney(posenc.dblPropina) }}</strong>
      </div>

      <v-textarea
        dense
        v-model="posenc.strNota"
        outlined
        auto-grow
        rows="1"
        label="Nota general"
        hide-details
        block
        @click="showKeyboard($event)"
        class="order-note"
      />

      <div class="order-summary">
        <div>
          <span>Subtotal</span>
          <strong>{{ toMoney(subtotalOrden) }}</strong>
        </div>

        <div v-if="descuentoOrden > 0">
          <span>Descuento</span>
          <strong>-{{ toMoney(descuentoOrden) }}</strong>
        </div>

        <div>
          <span>IVA</span>
          <strong>{{ toMoney(ivaOrden) }}</strong>
        </div>

        <div v-if="posenc.dblEnvio1 > 0">
          <span>Envío</span>
          <strong>{{ toMoney(posenc.dblEnvio1) }}</strong>
        </div>

        <div v-if="posenc.dblPropina > 0">
          <span>Propina</span>
          <strong>{{ toMoney(posenc.dblPropina) }}</strong>
        </div>
      </div>

      <div class="order-total">
        <span>Total</span>
        <strong>{{ toMoney(totalPago) }}</strong>
      </div>

      <div class="order-flow">
        <v-btn
          v-if="proceso == 1"
          class="flow-primary"
          block
          depressed
          @click="preparar()"
        >
          <span>PREPARAR</span>
          <strong>{{ toMoney(totalPago) }}</strong>
        </v-btn>

        <v-btn
          v-if="proceso == 2 && (!config_37_activo || !hayProductosNuevos)"
          class="flow-primary"
          block
          depressed
          @click="pago()"
        >
          <span>PAGO</span>
          <strong>{{ toMoney(totalPago) }}</strong>
        </v-btn>

        <v-btn
          v-if="proceso == 3"
          class="flow-secondary"
          block
          depressed
          @click="agregar()"
        >
          AGREGAR NUEVOS PRODUCTOS
        </v-btn>

        <v-btn
          v-if="config_37_activo && hayProductosNuevos && proceso == 2"
          class="flow-primary"
          block
          depressed
          @click="prepararNuevo()"
        >
          PREPARAR NUEVOS PRODUCTOS
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
var numeral = require("numeral");
var math = require("mathjs");
var moment = require("moment");
import { Toast, Session, ErrorWeb } from "../controllers/DataController.js";
import { POSEncFunctions } from "../controllers/POSController.js";
import Cookies from "js-cookie";
import Keyboard from "./Keyboard.vue";
export default {
  props: {
    configuracion3: {
      type: Object,
      default: () => {},
    },
    proceso: {
      type: Number,
      default: 1,
    },
    version: {
      type: String,
      default: "desktop",
    },
    value: {
      required: true,
    },
  },
  components: {
    Keyboard,
  },
  data() {
    return {
      tiempo: "",
      dialogPropina: false,
      porcentajePropina: 0,
      totalPago: 0.0,
      totalConsumo: 0.0,
      totalDescuento: 0.0,
      totalIVA: 0.0,
      session: new Session(),
      posenc: this.value,
      encFunctions: new POSEncFunctions(this.$config.api_backend_route),
      keyboardSession: false,
      panelAbierto: [],
      keyboard: {
        visible: false,
        input: null,
      },
      title: this.$config.ordenTitle,
      config_37_activo: this.$config.opciones.find((c) => c.id == 37).activo,
      btnTitle: this.$config.btnPreprar,
    };
  },
  methods: {
    showKeyboard(e) {
      if (this.keyboardSession && !this.disabled) {
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
    toPercent(value) {
      return numeral(value).format("0.00%");
    },
    toMoney(value) {
      return numeral(value).format("$0,0.00");
    },
    opcionesorden() {
      this.$emit("opcionorden", this.posenc);
    },
    opciones(detalle, index) {
      console.log("DETALLE OPCIONES");
      console.log(detalle);

      this.$emit("opciondetalle", { index: index, ...detalle });
    },
    imprimirDetalle(detalle, index) {
      this.$emit("imprimirdetalle", { index: index, ...detalle });
    },
    preparar() {
      this.loading = true;
      try {
        console.log("PREPARAR ORDENDETALLECOMP");
        console.log(this.posenc);
        this.$emit("preparar", this.posenc);
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
        this.posenc = null;
      } finally {
        this.loading = false;
      }
    },
    async prepararNuevo() {
      console.log("PREPARAR NUEVO");
      console.log(this.posenc);
      this.loading = true;
      try {
        const posencNuevo = JSON.parse(JSON.stringify(this.posenc));

        posencNuevo.posDet = posencNuevo.posDet.filter(
          (det) => det.intPreparado == null
        );

        this.$emit("prepararImprimir", posencNuevo);

        await this.encFunctions.actualizarPreparado(posencNuevo);
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
        this.posenc = null;
      } finally {
        setTimeout(() => {
          this.loading = false;
          location.reload();
        }, 2000);
      }
    },
    async pago() {
      this.loading = true;
      try {
        let posMOd = this.posenc.strUsuarioMod;
        let strUsuarioMod = Cookies.get("POS_USER")?.trim();
        if (strUsuarioMod === "" || strUsuarioMod === null) {
          strUsuarioMod = Cookies.get("POS_USER")?.trim();
        }
        posMOd = posMOd.toUpperCase();
        strUsuarioMod = strUsuarioMod.toUpperCase();
        if (this.posenc.intEstatus === 3) {
          if (this.configuracion3.valor) {
                   // console.log("configuracion3:", this.configuracion3);

            if (posMOd === strUsuarioMod || !strUsuarioMod || posMOd === "") {
              {
                this.$emit("prepararpagar", this.posenc);
              }
            } else {
              this.$toast.error(
                "El usuario que dio salida es el que la debe cobrar",
                new Toast()
              );
            }
          } else {
            if (posMOd === strUsuarioMod || !strUsuarioMod || posMOd === "") {
              this.$emit("pagar", this.posenc);
            } else {
              this.$toast.error(
                "El usuario que dio salida es el que la debe cobrar",
                new Toast()
              );
            }
          }
        } else {
          if (this.configuracion3.valor) {
            this.$emit("prepararpagar", this.posenc);
          } else {
            this.$emit("pagar", this.posenc);
          }
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    propina() {
      this.dialogPropina = true;
    },
    // agregarPropinaOrden() {
    //   this.dialogPropina = false;
    // },
    agregarPropinaOrden() {
  this.dialogPropina = false;

  if (!this.posenc.dblPropina || this.posenc.dblPropina <= 0) {
    this.posenc.dblPropina = 0.0;

    this.totalPago = math
      .chain(this.totalConsumo)
      .add(this.posenc.dblEnvio1 || 0)
      .done();

    this.totalPago = math.round(this.totalPago, 2);
    return;
  }

  this.totalPago = math
    .chain(this.totalConsumo)
    .add(this.posenc.dblEnvio1 || 0)
    .add(this.posenc.dblPropina)
    .done();

  this.totalPago = math.round(this.totalPago, 2);

  console.log("Subtotal consumo:", this.totalConsumo);
  console.log("Envío:", this.posenc.dblEnvio1);
  console.log("Propina:", this.posenc.dblPropina);
  console.log("TOTAL A PAGAR:", this.totalPago);
},
    imprimir() {
      this.$emit("imprimir", this.posenc);
    },
    agregar() {
      this.posenc.posDet = this.detalles;
      this.$emit("agregar", this.posenc);
    },
    calcularPropina() {
      if (!this.porcentajePropina || this.porcentajePropina <= 0) {
        this.posenc.dblPropina = 0.0;
        return;
      }

      let propina = math
        .chain(this.totalPago)
        .multiply(this.porcentajePropina)
        .divide(100)
        .done();

      this.posenc.dblPropina = math.round(propina);
    },

    contabilizarPago() {
      if (this.detalles.length > 0) {
        this.totalPago = this.detalles.reduce((a, b) => {
          console.log(b.dblCantidad);
          let iva = math
            .chain(b.dblPU)
            .multiply(b.dblCantidad)
            .multiply(b.dblPorcentajeIVA)
            .divide(100)
            .done();
          let ish = math
            .chain(b.dblPU)
            .multiply(b.dblCantidad)
            .multiply(b.dblPorcentajeISH)
            .divide(100)
            .done();
          let precio = math.chain(b.dblPU).multiply(b.dblCantidad).done();
          let x = math.chain(iva).add(ish).add(precio).done();
          let descuento = 0.0;

          if (b.intTipoDescuento == 1) {
            descuento = math
              .chain(x)
              .multiply(b.dblPorcentajeDescuento)
              .divide(100)
              .done();
          } else if (b.intTipoDescuento == 2) {
            descuento = math.chain(b.dblPorcentajeDescuento).done();
          }

          // let descuento = math
          //   .chain(x)
          //   .multiply(b.dblPorcentajeDescuento)
          //   .divide(100)
          //   .done();

          return math
            .chain(a)
            .add(math.round(precio, 2))
            .add(math.round(iva, 2))
            .add(math.round(ish, 2))
            .subtract(math.round(descuento, 2))
            .done();
        }, 0);
        console.log(this.totalPago);
        //  let pago=math.chain(this.totalPago).add(this.posenc.dblEnvio1);
        //  let pago=Math.round(this.totalPago,2)
        //  this.totalPago = math.chain(this.totalPago).add(this.posenc.dblEnvio1);
        // this.totalPago =  Math.round(pago,2)

        if (this.posenc.dblPorcentajeDescuento > 0) {
  this.totalConsumo = math
    .chain(this.totalPago)
    .subtract(math.round(this.posenc.dblImporteDescuento, 2))
    .done();
} else {
  this.totalConsumo = this.totalPago;
}

// Total normal de la orden + envío
this.totalPago = math
  .chain(this.totalConsumo)
  .add(this.posenc.dblEnvio1 || 0)
  .done();

} else {
  this.totalPago = 0.0;
}
      //this.totalPago = Math.round(this.totalPago);
      let total = math.round(this.totalPago, 2);
      let decimal = total % 1;

      if (Math.abs(decimal - 0.5) < 0.001) {
        // Si es .50 exacto, se queda así
        this.totalPago = total;
      } else {
        // En cualquier otro caso, entero normal
        this.totalPago = Math.round(total);
      }
    },
    openDetalle(indexDet) {
      //const indexDet = this.posenc.posDet.findIndex((obj => obj.intPOSEnc == detalle.intPOSEnc));
      if (this.posenc.posDet[indexDet].open) {
        this.posenc.posDet[indexDet].icon = "fas fa-arrow-up";
        this.posenc.posDet[indexDet].open = false;
      } else {
        this.posenc.posDet[indexDet].icon = "fas fa-arrow-down";
        this.posenc.posDet[indexDet].open = true;
      }
    },
  },
  computed: {
    mostrarPrepararNuevo() {
      if (!this.config_37_activo) return false;

      return this.detalles.some((detalle) => detalle.intPreparado == null);
    },
    hayProductosNuevos() {
      if (!this.config_37_activo) return false;

      return this.detalles.some((detalle) => detalle.intPreparado == null);
    },
    detalles() {
      return this.posenc.posDet.filter(
        (detalle) => detalle.intEstatus != 8 && detalle.intEstatus != 9
      );
    },
    detallesCancelados() {
      return this.posenc.posDet.filter(
        (detalle) => detalle.intEstatus == 8 || detalle.intEstatus == 9
      );
    },

    // Desglose visual de la orden.
    // Utiliza la misma base que contabilizarPago(), sin modificar el cálculo
    // ni los eventos existentes.
    subtotalOrden() {
      return this.detalles.reduce((total, detalle) => {
        const precio = Number(detalle.dblPU || 0) * Number(detalle.dblCantidad || 0);
        return total + precio;
      }, 0);
    },

    ivaOrden() {
      return this.detalles.reduce((total, detalle) => {
        const precio = Number(detalle.dblPU || 0) * Number(detalle.dblCantidad || 0);
        const iva = precio * Number(detalle.dblPorcentajeIVA || 0) / 100;
        return total + iva;
      }, 0);
    },

    descuentoOrden() {
      const descuentoDetalles = this.detalles.reduce((total, detalle) => {
        const precio = Number(detalle.dblPU || 0) * Number(detalle.dblCantidad || 0);
        const iva = precio * Number(detalle.dblPorcentajeIVA || 0) / 100;
        const ish = precio * Number(detalle.dblPorcentajeISH || 0) / 100;
        const baseDescuento = precio + iva + ish;

        let descuento = 0;

        if (detalle.intTipoDescuento == 1) {
          descuento =
            baseDescuento *
            Number(detalle.dblPorcentajeDescuento || 0) /
            100;
        } else if (detalle.intTipoDescuento == 2) {
          descuento = Number(detalle.dblPorcentajeDescuento || 0);
        }

        return total + descuento;
      }, 0);

      // Descuento global de la orden, si existe.
      const descuentoGlobal =
        Number(this.posenc.dblImporteDescuento || 0);

      return descuentoDetalles + descuentoGlobal;
    },
  },
  mounted() {
    console.log("DETALLES");
    console.log(this.detalles);

    this.detalles.forEach((detalle, index) => {
      console.log(`DETALLE ${index}`, detalle);
    });

    setInterval(() => (this.tiempo = moment().format("LTS")), 1000);
    this.contabilizarPago();
    this.keyboardSession = new Session().keyboard;
  },
  watch: {
    porcentajePropina: {
      handler() {
        this.calcularPropina();
      },
      deep: true,
    },
    posenc: {
      handler(newValue) {
        this.contabilizarPago();
        this.$emit("input", newValue);
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.posenc = newValue;

        //this.newValue.strNombre=newValue.cliente.strNombre;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* ============================================================
   TPV · DETALLE DE ORDEN
   Adaptación visual del panel "ticket" del rediseño.
   No modifica la lógica ni los eventos del componente.
   ============================================================ */

.orden-detalle-redesign {
  --detail-primary: #113e75;
  --detail-primary-hover: #0c2b52;
  --detail-primary-light: #58789e;
  --detail-primary-tint: #e9eef4;
  --detail-secondary: #b92340;
  --detail-success: #fe9000;
  --detail-bg: #f4f5f7;
  --detail-surface: #ffffff;
  --detail-surface-alt: #fafbfc;
  --detail-border: #e2e4e8;
  --detail-border-strong: #c7cbd1;
  --detail-text: #1a1d23;
  --detail-text-soft: #33363c;
  --detail-muted: #6b7280;
  --detail-error: #bc3441;
  --detail-r-sm: 8px;
  --detail-r-md: 14px;
  --detail-r-lg: 20px;

  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--detail-border);
  border-radius: var(--detail-r-md) !important;
  box-shadow: 0 3px 12px rgba(17, 29, 45, .045) !important;
  color: var(--detail-text);
  font-family: 'Inter', Arial, sans-serif;
}

/* ---------- Cabecera ---------- */

.orden-head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 18px 15px;
  border-bottom: 1px solid var(--detail-border);
  background: var(--detail-surface);
}

.orden-head-main {
  min-width: 0;
  flex: 1;
}

.orden-kicker {
  margin-bottom: 4px;
  color: var(--detail-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.orden-head h2 {
  margin: 0;
  color: var(--detail-text);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -.025em;
  line-height: 1.2;
}

.orden-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 7px 12px;
  margin-top: 6px;
  color: var(--detail-muted);
  font-size: 11px;
}

.orden-meta span + span {
  position: relative;
  padding-left: 12px;
}

.orden-meta span + span::before {
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--detail-border-strong);
  content: "";
  transform: translateY(-50%);
}

.orden-head-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 3px;
}

.detail-icon-btn,
.item-action {
  display: grid;
  place-items: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--detail-r-sm);
  background: transparent;
  color: var(--detail-muted);
  transition: .15s ease;
}

.detail-icon-btn {
  width: 38px;
  height: 38px;
}

.detail-icon-btn:hover,
.item-action:hover {
  border-color: var(--detail-border);
  background: var(--detail-primary-tint);
  color: var(--detail-primary);
}

.detail-icon-btn:focus-visible,
.item-action:focus-visible,
.item-toggle:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(88, 120, 158, .20);
}

.orden-mobile-actions {
  display: none;
}

/* ---------- Cuerpo ---------- */

.orden-body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
  background: var(--detail-surface);
}

.orden-section-label {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  padding: 11px 18px 7px;
  color: var(--detail-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .05em;
  text-transform: uppercase;
}

.orden-count {
  min-width: 22px;
  padding: 3px 7px;
  border-radius: 999px;
  background: var(--detail-primary-tint);
  color: var(--detail-primary);
  font-size: 10px;
  text-align: center;
}

.orden-items {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 18px 8px;
  scrollbar-width: thin;
}

.redesign-expansion {
  padding: 0 !important;
  box-shadow: none !important;
}

.redesign-expansion::before,
.redesign-expansion::after {
  display: none !important;
}

.redesign-item {
  margin: 0 !important;
  border-bottom: 1px solid var(--detail-border) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

.redesign-item:last-child {
  border-bottom: 0 !important;
}

.redesign-item::before {
  display: none !important;
}

.redesign-item-header {
  min-height: 54px !important;
  height: auto !important;
  padding: 9px 0 !important;
  background: transparent !important;
  color: var(--detail-text) !important;
}

.redesign-item-header:hover {
  background: var(--detail-surface-alt) !important;
}

.redesign-item-header /deep/ .v-expansion-panel-header__icon {
  display: none !important;
}

.redesign-item-header /deep/ .v-expansion-panel-header__icon .v-icon {
  display: none !important;
}

.redesign-item-header::before {
  display: none !important;
}

.item-summary {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.item-main {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 8px;
}

.item-title-row {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 7px;
}

.item-name {
  min-width: 0;
  overflow: hidden;
  color: var(--detail-text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-price {
  flex: none;
  color: var(--detail-text);
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.new-chip {
  flex: none;
  height: 20px !important;
  margin: 0 !important;
  border-radius: 999px !important;
  background: var(--detail-primary-tint) !important;
  color: var(--detail-primary) !important;
  font-size: 9px !important;
  font-weight: 800 !important;
}

.item-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 2px;
}

.item-action {
  width: 32px;
  height: 32px;
}

.item-action /deep/ .v-icon,
.detail-icon-btn /deep/ .v-icon {
  font-size: 19px !important;
}

.item-toggle {
  display: grid;
  flex: none;
  width: 36px;
  height: 36px;
  place-items: center;
  padding: 0;
  border: 1.5px solid var(--detail-border-strong);
  border-radius: var(--detail-r-sm);
  background: var(--detail-surface);
  color: var(--detail-primary);
  transition: .15s ease;
}

.item-toggle:hover {
  border-color: var(--detail-primary);
  background: var(--detail-primary-tint);
}

.redesign-item.v-expansion-panel--active .item-toggle {
  border-color: var(--detail-primary);
  background: var(--detail-primary-tint);
}

.redesign-item.v-expansion-panel--active .item-toggle /deep/ .v-icon {
  transform: rotate(180deg);
}

.item-toggle /deep/ .v-icon {
  font-size: 22px !important;
  transition: transform .16s ease;
}

.redesign-item-content {
  padding: 0 0 10px !important;
}

.redesign-item-content /deep/ .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.detail-content {
  padding: 11px 12px 12px;
  border-radius: var(--detail-r-sm);
  background: var(--detail-surface-alt);
  color: var(--detail-text-soft);
  font-size: 11px;
  line-height: 1.4;
}

.detail-subtitle {
  margin-bottom: 7px;
  color: var(--detail-muted);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.detail-configurations {
  margin-bottom: 10px;
  padding-bottom: 9px;
  border-bottom: 1px solid var(--detail-border);
}

.configuration-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
}

.configuration-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.configuration-row strong {
  flex: none;
  color: var(--detail-text);
  font-variant-numeric: tabular-nums;
}

.detail-overview {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 9px;
  border-bottom: 1px solid var(--detail-border);
}

.detail-overview-grid {
  display: grid;
  min-width: 0;
  flex: 1;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 14px;
}

.detail-overview-grid div {
  min-width: 0;
}

.detail-overview-grid span {
  display: block;
  margin-bottom: 2px;
  color: var(--detail-muted);
  font-size: 9px;
}

.detail-overview-grid strong {
  color: var(--detail-text);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}

.detail-subtotal {
  flex: none;
  min-width: 92px;
  text-align: right;
}

.detail-subtotal span {
  display: block;
  margin-bottom: 2px;
  color: var(--detail-muted);
  font-size: 9px;
}

.detail-subtotal strong {
  color: var(--detail-text);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.detail-note {
  margin-top: 10px;
}

.detail-note /deep/ .v-text-field,
.detail-note /deep/ .v-textarea {
  margin-top: 0;
}

.detail-note /deep/ .v-input__slot {
  min-height: 38px !important;
  margin-bottom: 0 !important;
  padding: 0 10px !important;
  border: 1px solid var(--detail-border-strong) !important;
  border-radius: var(--detail-r-sm) !important;
  background: #fff !important;
}

.detail-note /deep/ textarea {
  font-size: 11px !important;
}

.detail-note /deep/ .v-label {
  font-size: 11px !important;
}

.detail-note /deep/ .v-text-field__details,
.detail-note /deep/ .v-input__details {
  display: none !important;
}

/* ---------- Cancelados y envío ---------- */

.redesign-item-cancelled {
  opacity: .92;
}

.redesign-item-cancelled .item-name,
.redesign-item-cancelled .item-price {
  color: var(--detail-muted);
  text-decoration: none;
}

.cancelled-badge {
  flex: none;
  padding: 5px 8px;
  border-radius: 999px;
  background: #fdeaec;
  color: var(--detail-error);
  font-size: 9px;
  font-weight: 800;
}

.cancelled-content p {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin: 0;
}

.cancelled-content p + p {
  margin-top: 8px;
}

.cancelled-content strong {
  color: var(--detail-error);
}

.cancelled-content span {
  color: var(--detail-muted);
}

.shipping-badge {
  display: grid;
  width: 28px;
  height: 28px;
  flex: none;
  place-items: center;
  border-radius: 50%;
  background: var(--detail-primary-tint);
  color: var(--detail-primary);
}

.shipping-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shipping-content strong {
  color: var(--detail-text);
  font-variant-numeric: tabular-nums;
}

/* ---------- Estado vacío ---------- */

.orden-empty {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  padding: 25px;
  color: var(--detail-muted);
  text-align: center;
}

.empty-icon {
  display: grid;
  width: 46px;
  height: 46px;
  margin-bottom: 4px;
  place-items: center;
  border-radius: 50%;
  background: var(--detail-primary-tint);
  color: var(--detail-primary);
}

.empty-icon /deep/ .v-icon {
  font-size: 24px !important;
}

.orden-empty strong {
  color: var(--detail-text);
  font-size: 13px;
}

.orden-empty span {
  font-size: 11px;
}

/* ---------- Pie / resumen ---------- */

.orden-foot {
  flex: 0 0 auto;
  padding: 11px 18px 15px;
  border-top: 1px solid var(--detail-border);
  background: var(--detail-surface-alt);
}

.tip-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
  padding: 7px 9px;
  border-radius: var(--detail-r-sm);
  background: #fff1df;
  color: var(--detail-text-soft);
  font-size: 11px;
}

.tip-row strong {
  color: var(--detail-text);
  font-variant-numeric: tabular-nums;
}

.order-note {
  margin: 0 0 9px !important;
}

.order-note /deep/ .v-input__slot {
  min-height: 42px !important;
  margin-bottom: 0 !important;
  padding: 0 11px !important;
  border: 1px solid var(--detail-border-strong) !important;
  border-radius: var(--detail-r-sm) !important;
  background: #fff !important;
}

.order-note /deep/ .v-label {
  font-size: 11px !important;
}

.order-note /deep/ textarea {
  font-size: 12px !important;
}

.order-note /deep/ .v-text-field__details,
.order-note /deep/ .v-input__details {
  display: none !important;
}

.order-summary {
  padding: 10px 0 6px;
  border-bottom: 1px solid var(--detail-border);
}

.order-summary > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  color: var(--detail-muted);
  font-size: 13px;
  line-height: 1.35;
}

.order-summary > div strong {
  color: var(--detail-text);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.order-summary > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--detail-text-soft);
  font-size: 11px;
}

.order-summary strong {
  color: var(--detail-text);
  font-variant-numeric: tabular-nums;
}

.order-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 7px 0 10px;
  padding-top: 8px;
  border-top: 1px solid var(--detail-border);
  color: var(--detail-text);
  font-size: 14px;
  font-weight: 700;
}

.order-total strong {
  color: var(--detail-primary);
  font-size: 24px;
  font-variant-numeric: tabular-nums;
}

.order-flow {
  display: grid;
  gap: 7px;
}

.order-flow /deep/ .v-btn {
  min-height: 46px !important;
  height: auto !important;
  border-radius: var(--detail-r-sm) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: .01em !important;
}

.flow-primary {
  background: var(--detail-primary) !important;
  color: #fff !important;
}

.flow-primary:hover {
  background: var(--detail-primary-hover) !important;
}

.flow-primary strong {
  margin-left: 5px;
}

.flow-secondary {
  border: 1.5px solid var(--detail-primary) !important;
  background: #fff !important;
  color: var(--detail-primary) !important;
}

/* ---------- Dialog ---------- */

.redesign-dialog {
  border-radius: var(--detail-r-lg) !important;
}

.redesign-dialog-title {
  padding: 20px 24px 10px !important;
  border-bottom: 1px solid var(--detail-border);
}

.dialog-kicker {
  display: block;
  margin-bottom: 3px;
  color: var(--detail-muted);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.redesign-dialog-title strong {
  color: var(--detail-text);
  font-size: 18px;
}

.redesign-dialog-body {
  padding: 20px 24px 8px !important;
}

.redesign-dialog-body /deep/ .v-input__slot {
  border-radius: var(--detail-r-sm) !important;
}

.redesign-dialog-actions {
  padding: 12px 24px 18px !important;
  border-top: 1px solid var(--detail-border);
  background: var(--detail-surface-alt);
}

.redesign-primary-btn {
  border-radius: var(--detail-r-sm) !important;
  background: var(--detail-primary) !important;
}

/* ---------- Responsive ---------- */

@media (min-width: 1500px) {
  .orden-head {
    padding: 19px 20px 16px;
  }

  .orden-head h2 {
    font-size: 21px;
  }

  .orden-meta,
  .item-name,
  .item-price {
    font-size: 13px;
  }

  .orden-section-label {
    font-size: 11px;
  }

  .redesign-item-header {
    min-height: 58px !important;
    padding: 10px 0 !important;
  }

  .item-name,
  .item-price {
    font-size: 14px;
  }

  .item-action {
    width: 34px;
    height: 34px;
  }

  .item-toggle {
    width: 38px;
    height: 38px;
  }

  .detail-content {
    font-size: 12px;
  }

  .detail-overview-grid span,
  .detail-subtotal span {
    font-size: 10px;
  }

  .detail-overview-grid strong {
    font-size: 12px;
  }

  .order-summary > div {
    font-size: 12px;
  }

  .order-total {
    font-size: 15px;
  }

  .order-total strong {
    font-size: 27px;
  }

  .order-flow /deep/ .v-btn {
    min-height: 49px !important;
    font-size: 12px !important;
  }
}

@media (max-width: 800px) {
  .orden-detalle-redesign {
    height: auto;
    min-height: 100%;
  }

  .orden-head {
    padding: 14px 15px 12px;
  }

  .orden-head-actions {
    display: none;
  }

  .orden-mobile-actions {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 7px;
    padding: 8px 15px;
    border-bottom: 1px solid var(--detail-border);
    background: var(--detail-surface);
  }

  .orden-mobile-actions button {
    display: flex;
    min-height: 40px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    border: 1px solid var(--detail-border);
    border-radius: var(--detail-r-sm);
    background: #fff;
    color: var(--detail-text-soft);
    font-size: 10px;
    font-weight: 700;
  }

  .orden-mobile-actions button:hover {
    border-color: var(--detail-primary-light);
    background: var(--detail-primary-tint);
    color: var(--detail-primary);
  }

  .orden-items {
    padding: 0 14px 8px;
  }

  .orden-foot {
    padding: 10px 14px 14px;
  }

  .item-name {
    font-size: 12px;
  }

  .item-price {
    font-size: 12px;
  }

  .detail-overview {
    flex-direction: column;
  }

  .detail-subtotal {
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  .detail-subtotal span {
    margin: 0;
  }
}

@media (max-width: 520px) {
  .orden-head h2 {
    font-size: 17px;
  }

  .orden-meta {
    font-size: 10px;
  }

  .item-main {
    gap: 5px;
  }

  .item-actions {
    gap: 0;
  }

  .item-action {
    width: 29px;
    height: 31px;
  }

  .item-toggle {
    width: 32px;
    height: 32px;
  }

  .item-action /deep/ .v-icon {
    font-size: 17px !important;
  }

  .item-toggle /deep/ .v-icon {
    font-size: 20px !important;
  }

  .item-price {
    display: none;
  }

  .order-total strong {
    font-size: 22px;
  }
}
</style>
